// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3ki8C","approved":"Status_approved__2d601","rejected":"Status_rejected__2kwMk","expired":"Status_expired__24g8L","label":"Status_label__3vjw1"};